export type languages =
  | "ja"
  | "en"
  | "zh-CN"
  | "zh-TW"
  | "ko"
  | "vi"
  | "ti"
  | "th"
  | "pt"
  | "bn";

export class SurveyText {
  constructor(public lang: languages, public text: string) {}

  static getInstances(querys: string[]) {
    if (!querys) {
      return [];
    }
    return querys.map(SurveyText.getInstance);
  }

  static getInstance(query: string) {
    return new SurveyText(query[0] as languages, query[1]);
  }
}

export const findTextOfTargetLanguage = function(
  surveyTexts: SurveyText[],
  lang: languages
) {
  return surveyTexts.find(v => v.lang === lang)?.text ?? "";
};
